"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractName = exports.personVisaSubmissionText = exports.personVisaOptionLabels = exports.visaOptions = void 0;
const immutable_1 = require("immutable");
const profile_parser_1 = require("profile-parser");
exports.visaOptions = [
    'no_visa_needed',
    'h4_l2_ead',
    'h1b_visa_h1b_needed',
    'h1b_visa_needs_transfer',
    'h1b_visa_new_h1b_needed_not_in_us',
    'h1b_visa_gc_sponsorship_needed',
    'h1b_visa_i140_approved',
    'tn_e3_visa',
    'o1',
    'other'
];
exports.personVisaOptionLabels = (0, immutable_1.OrderedMap)([
    ['no_visa_needed', 'No visa needed: Citizen/GC'],
    ['h4_l2_ead', 'No Visa needed: H4/L2 EAD'],
    ['h1b_visa_h1b_needed', 'Visa needed: On F1/OPT (Needs brand new H1B)'],
    ['h1b_visa_needs_transfer', 'Visa needed: H1B Transfer'],
    ['h1b_visa_new_h1b_needed_not_in_us', 'Visa needed: Not living in US'],
    ['h1b_visa_gc_sponsorship_needed', 'Visa needed: H1B Transfer (start GC process)'],
    ['h1b_visa_i140_approved', 'Visa needed: H1B Transfer (I140 Approved, continue GC)'],
    ['tn_e3_visa', 'Visa needed: TN/E3 (Can/Mexico/Aus)'],
    ['o1', 'Visa needed: O1 filing'],
    ['other', "Can't transfer: L1/O2/3/J1/2/Nonprofit H1B"]
]);
exports.personVisaSubmissionText = {
    h1b_visa_gc_sponsorship_needed: 'Visa needed - H1B transfer',
    h1b_visa_h1b_needed: 'Visa needed - Currently on OPT and new H1B filing needed',
    h1b_visa_i140_approved: 'Visa needed - H1B transfer',
    h1b_visa_needs_transfer: 'Visa needed - H1B transfer',
    h1b_visa_new_h1b_needed_not_in_us: 'Visa needed - Not living in US',
    h4_l2_ead: 'No Visa needed - H4 EAD/L2 EAD',
    no_visa_needed: 'No visa needed - US Citizen/GC',
    o1: 'Visa needed - O1 visa (easier than H1B transfer)',
    other: 'Visa needed - new H1B filing',
    tn_e3_visa: 'Visa needed - TN/E3 visa (much easier than H1B transfer!)'
};
function extractName(name) {
    if (name.edited) {
        return name;
    }
    return (0, profile_parser_1.standardizeName)(name);
}
exports.extractName = extractName;
//# sourceMappingURL=person.js.map